/* Quilted Joy nav — hover-intent dropdown engine.
   Ported from Stage 2 to also drive the live two-row nav: handles Stage 2
   single-row items (.qj-navitem[data-qj-haspanel]) AND the legacy two-row
   items (.mgmenu_item.slide_item / .ex-mgmenu_item.slide_item), whose panels
   are shown via the .qj-open class (see qj-header.css).
   Hover remains the primary interaction (per owner preference); Baymard-range
   grace timers stop menus opening by accident or closing mid-reach: ~300ms to
   open, ~450ms before closing, 120ms when switching between items so browsing
   feels fluid. Escape closes, keyboard focus opens, and span-only labels
   click-toggle for trackpad users. */
(function () {
  if (window.__qjNavBound) return;
  window.__qjNavBound = true;

  var OPEN_DELAY = 300;
  var SWITCH_DELAY = 120;
  var CLOSE_DELAY = 450;

  function init() {
    var items = Array.prototype.slice.call(
      document.querySelectorAll(
        '.qj-navitem[data-qj-haspanel], .mgmenu_item.slide_item, .ex-mgmenu_item.slide_item'
      )
    );
    if (!items.length) return;

    var openItem = null;
    var openTimer = null;
    var closeTimer = null;

    function getLabel(item) {
      return (
        item.querySelector(':scope > .qj-navitem__label') ||
        item.querySelector(':scope > a, :scope > span')
      );
    }

    function setExpanded(item, on) {
      var label = getLabel(item);
      if (label) label.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function positionPanel(item) {
      var panel = item.querySelector(':scope > .qj-panel');
      if (!panel || !panel.classList.contains('qj-panel--machines')) return;
      var bar = item.closest('section.mega--menu');
      if (!bar) return;
      var barRect = bar.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var panelWidth = Math.max(panel.offsetWidth, 520);
      var left = itemRect.left - barRect.left;
      var maxLeft = barRect.width - panelWidth - 10;
      panel.style.left = Math.max(0, Math.min(left, maxLeft)) + 'px';
    }

    function closeNow(item) {
      if (!item) return;
      item.classList.remove('qj-open');
      setExpanded(item, false);
      if (openItem === item) openItem = null;
    }

    function openNow(item) {
      if (openItem && openItem !== item) closeNow(openItem);
      positionPanel(item);
      item.classList.add('qj-open');
      setExpanded(item, true);
      openItem = item;
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        var delay = openItem ? SWITCH_DELAY : OPEN_DELAY;
        openTimer = setTimeout(function () {
          openNow(item);
        }, delay);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          closeNow(item);
        }, CLOSE_DELAY);
      });

      item.addEventListener('focusin', function () {
        clearTimeout(closeTimer);
        openNow(item);
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) closeNow(item);
      });

      var label = getLabel(item);
      if (label && label.tagName !== 'A') {
        label.addEventListener('click', function () {
          clearTimeout(openTimer);
          if (item.classList.contains('qj-open')) {
            closeNow(item);
          } else {
            openNow(item);
          }
        });
        label.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            label.click();
          }
        });
      }
    });

    document.addEventListener('keyup', function (event) {
      if (event.key === 'Escape' && openItem) {
        var label = getLabel(openItem);
        closeNow(openItem);
        if (label && label.focus) label.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (openItem && !openItem.contains(event.target)) closeNow(openItem);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
